if (!customElements.get('lookbook-img')) {
  customElements.define('lookbook-img', class Lookbook extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        pinType: this.querySelectorAll('.pin__type'),
        productInclude: this.querySelectorAll('[data-include]')
      }

      this.loadProduct();

      if (this.elements.pinType.length > 0) {
        this.loadClick();
      }
    }

    loadClick() {
      this.elements.pinType.forEach((pin) => {
        pin.addEventListener('click', (e) => {
          const slideLookbook = document.querySelector('.splide-lookbook');
          if (!slideLookbook) return;
          const similarBlock = e.target.closest('.pin__type').dataset.block;
          slideLookbook.querySelectorAll('.splide__slide').forEach((element) => element.classList.remove('active'));
          document.querySelectorAll('.lookbook-wrapper .pin__type').forEach((element) => element.classList.remove('active'));
          slideLookbook.querySelector(`.${similarBlock}`).classList.add('active');
          e.target.closest('.pin__type').classList.add('active');
        })
      })
    }

    loadProduct() {
      this.elements.productInclude.forEach((productElement) => {
        const productUrl = productElement.dataset.include;
        fetch(productUrl)
          .then(response => response.text())
          .then((responseText) => {
            productElement.innerHTML = responseText;
          });
      })
    }
  });
}
